import { HotelContractModel } from "../../models"

// Local interface for internal state management (extends the model for UI purposes)
export interface DayWisePricingGroupLocal {
    day_wise_pricing_group_id: string | null
    day_wise_pricing_group_name: string | null
    flag_surchange_applied: boolean
    surcharge_amount: number | null
    /** true => surcharge_amount is a percentage; false/undefined => flat VND amount */
    flag_surcharge_amount_is_percentage?: boolean
    day_wise_pricing_group_surcharge: {
        flag_different_surcharge: boolean
        surcharge_amount: number | null
        flag_surcharge_amount_is_percentage?: boolean
    }[]
    days: number[] // Simplified for UI - will be converted to pricing_group_day on save
    flag_disabled: boolean
    flag_enable_day_group_in_rate_table: boolean
    sequence: number
}

// Use the global SeasonDateRangeModel but with local IDs for new entries
export interface SeasonDateRangeLocal {
    range_id: string
    season_id: string
    start_date: string
    end_date: string
}

// Local interface for peak date ranges
export interface PeakDateRangeLocal {
    range_id: string
    start_date: string
    end_date: string
    flag_compulsory_meal: boolean
    flag_different_surcharge: boolean
}

export const WEEK_DAYS = [
    
    { id: 1, name: "Mon", label: "Monday" },
    { id: 2, name: "Tue", label: "Tuesday" },
    { id: 3, name: "Wed", label: "Wednesday" },
    { id: 4, name: "Thu", label: "Thursday" },
    { id: 5, name: "Fri", label: "Friday" },
    { id: 6, name: "Sat", label: "Saturday" },
    { id: 7, name: "Sun", label: "Sunday" },
]

/** Section of the contract form that a validation error belongs to (drives inline error placement). */
export type HotelContractErrorKey =
    | "contractDates"
    | "seasonName"
    | "seasonDateRanges"
    | "perPersonSeasonalSurcharge"
    | "dayWisePricing"
    | "rateStructure"
    | "peakDateSurcharges"
    | "extraBedPricing"

export interface IHotelContractValidationError {
    key: HotelContractErrorKey
    /** Human-readable field label shown in the validation errors popup. */
    field: string
    message: string
}

export interface HotelContractProps {
    contract: HotelContractModel[]
    /** Stable id for day-wise pricing context (e.g. contract_id or `local-${index}`). */
    dayWisePricingScopeId: string
    onChange?: (updatedContract: HotelContractModel) => void
    validateContractDates?: (startDate: string | null, endDate: string | null) => string[]
    /** Called with the full list of contract validation errors whenever it changes (empty list = valid). */
    onErrorStatusChange?: (errors: IHotelContractValidationError[]) => void
    showValidationErrors?: boolean
}
